import { useQuery } from "@tanstack/react-query";
import { piCycleTopChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { PiCycleTopQueryParams } from "@/types/indices";

export const usePiCycleTopChart = (params?: PiCycleTopQueryParams) => {
  return useQuery(piCycleTopChartQueryOptions(params));
};
